module.exports = __webpack_public_path__ + "fonts/MillerBanner-Light.2b63f50c6679a0edc488e247278d5e8e.woff2";